document.addEventListener("DOMContentLoaded", function () {
  const timers = document.querySelectorAll(".product-card-timer");

  if (!timers.length) return;

  timers.forEach((timerBox) => {
    const endTime = timerBox.getAttribute("data-end");
    const countdown = timerBox.querySelector(".product-card-countdown");
    const end = new Date(endTime).getTime();

    function updateTimer() {
      const now = new Date().getTime();
      const distance = end - now;

      if (distance <= 0) {
        countdown.innerHTML = "Expired";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdown.innerHTML = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  });
});